import React, { useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
import WizardWrapper from './WizardWrapper';
import useWizardForm from './useWizardForm';
import useAssessorWizard from './useAssessorWizard';
import ModalConfirmation from '../../ModalConfirmation';
import Notification from '../../Notification';
import { getRefereeSchema } from '../Validation/ValidationIndependentAssessor';

const IndependentAssessorForm = ({
  formName,
  formStatus,
  refereeReportData,
  onSubmitHandler,
  initialFormData,
}) => {
  const refereeNumber = formName.replace('referee', '');
  const schema = getRefereeSchema(refereeNumber);

  const { setValue, trigger, wrapperProps } = useWizardForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (initialFormData) {
      Object.keys(initialFormData).forEach((key) => {
        setValue(key, initialFormData[key]);
      });
      trigger();
    }
  }, [initialFormData, setValue, trigger]);

  return (
    <WizardWrapper
      {...wrapperProps}
      activeMenu="Independent Assessor"
      motherMenu="Home"
      formName={formName}
      onSubmit={onSubmitHandler}
      formStatusId={formStatus}
      refereeReportData={refereeReportData}
    />
  );
};

IndependentAssessorForm.propTypes = {
  formName: PropTypes.string.isRequired,
  formStatus: PropTypes.number.isRequired,
  refereeReportData: PropTypes.object.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  initialFormData: PropTypes.object,
};

const WizardIndependentAssessor = () => {
  const {
    formStatus,
    refereeReportData,
    isRedirecting,
    showModal,
    modalBodyText,
    formName,
    notification,
    initialFormData,
    isLoading,
    onSubmit,
    handleCancelSelect,
    handleConfirmSelect,
  } = useAssessorWizard();

  if (isLoading || !formName) {
    return (
      <>
        {notification && (
          <Notification
            message={notification.message}
            title={notification.title}
          />
        )}
        <div className="d-flex justify-content-center align-items-center p-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {notification && (
        <Notification
          message={notification.message}
          title={notification.title}
        />
      )}

      <IndependentAssessorForm
        key={formName}
        formName={formName}
        formStatus={formStatus}
        refereeReportData={{
          ...refereeReportData,
          isRedirecting,
        }}
        onSubmitHandler={onSubmit}
        initialFormData={initialFormData}
      />

      <ModalConfirmation
        showModal={showModal}
        handleCancelSelect={handleCancelSelect}
        bodyText={modalBodyText}
        handleConfirmSelect={handleConfirmSelect}
      />
    </>
  );
};

export default WizardIndependentAssessor;
